import { useAppDispatch } from '../app/hooks';
import { login } from '../utils/createAuthProvider';
import { getMyProfile } from '../utils/axiosRequest';
import { bumpProfileVersion } from '../features/appConfig/appConfigSlice';

/**
 * Shared "successful login" routine used by both the Login page and the
 * session-expired AuthModal.
 *
 * Stores the new access token, then re-fetches the profile that `login()` just
 * cleared so permission-driven UI (e.g. the Sidebar, which reads the cached
 * profile from localStorage non-reactively) isn't left blank, and finally bumps
 * `profileVersion` so those consumers re-render with the fresh profile.
 */
export const useLogin = () => {
  const dispatch = useAppDispatch();

  return async (accessToken: string) => {
    login(accessToken);
    await getMyProfile();
    dispatch(bumpProfileVersion());
  };
};
